import { AppWindow, Cpu } from 'lucide-react';

/** Eyebrow marker for the two divisions of the platform: Hardware, and Software & licences. */
export function DomainEyebrow({ domain, children }: { domain: 'hardware' | 'software'; children?: string }) {
  const Icon = domain === 'hardware' ? Cpu : AppWindow;
  return (
    <span className="domain-tag">
      <Icon aria-hidden strokeWidth={2} />
      {domain === 'hardware' ? 'Hardware' : 'Software & licences'}
      {children ? <span className="text-fg-3"> · {children}</span> : null}
    </span>
  );
}
